import type React from 'react';
import type { FC } from 'react';

import { Draggable } from 'react-beautiful-dnd';

import type { DraggableContainerProps } from './types';

const DraggableContainer: FC<
  React.PropsWithChildren<DraggableContainerProps>
> = ({ children, draggableId, index }) => {
  return (
    <Draggable draggableId={draggableId} index={index}>
      {provided => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {children}
        </div>
      )}
    </Draggable>
  );
};

export default DraggableContainer;
